import React, { useMemo } from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
const useStyles = makeStyles((theme) => createStyles({
    container: {
        height: '100%',
        width: '100%',
        overflow: 'auto'
    },
    withoutTable: {
        padding: theme.spacing(3)
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column'
    },
    withTable: ({ tableClassName }) => {
        const styles = ({
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: theme.spacing(3),
            paddingTop: theme.spacing(3),
            [`& > *:not(.${tableClassName})`]: {
                marginRight: theme.spacing(3)
            }
        });
        if (tableClassName) {
            styles[`& > *:not(.${tableClassName})`] = {
                marginRight: theme.spacing(3)
            };
        }
        return styles;
    }
}));
function FullWidthPage({ children, className = '', noPaddingTop, nextToSideBar, flexColumn, withTable }) {
    const classes = useStyles({ tableClassName: withTable });
    const computedStyles = useMemo(() => {
        const s = {};
        if (noPaddingTop)
            s.paddingTop = 0;
        if (nextToSideBar)
            s.paddingLeft = 8;
        return s;
    }, [noPaddingTop, nextToSideBar]);
    const computedClasses = useMemo(() => {
        const c = [];
        if (withTable)
            c.push(classes.withTable);
        if (!withTable)
            c.push(classes.withoutTable);
        if (flexColumn)
            c.push(classes.flexColumn);
        return c.join(' ');
    }, [classes, withTable, flexColumn]);
    return (React.createElement("div", { className: `${classes.container} ${computedClasses} ${className}`, style: computedStyles }, children));
}
export default FullWidthPage;
